export default {
  // 登入
  login: 'companyadmin/v210623/login/index',
  // 导航
  get_tree: 'companyadmin/v210623/index/get_tree',
  // 首页
  home: 'companyadmin/v210623/index/index',
  // 退出登录
  sign_out: 'companyadmin/v210623/index/out',
  // 修改密码
  company_edit_password: 'companyadmin/v210623/company/edit_password',
  // 公司数据
  company_index: 'companyadmin/v210623/company/index',
  // 系统公告
  company_news: '/companyadmin/v210623/index/news',
  // 首页-数据概况
  home_survey: 'companyadmin/v210623/index/data_survey',
  // 首页-数据指标
  home_chart: '/companyadmin/v210623/index/line_chart',
  // 趋势图
  home_trend_chart: '/companyadmin/v210623/index/trend_chart',
  // 留存分析
  home_retained_analysis: '/companyadmin/v210623/index/retained_analysis',
  // 用户活跃度
  home_user_activation: '/companyadmin/v210623/index/user_activation',
  // top场景值
  home_sence: '/companyadmin/v210623/index/sence',
  // top场景值
  home_qr_stat: '/companyadmin/v210623/index/qr_stat',
  // 商品列表
  goods_index: '/companyadmin/v210623/goods/index',
  decorate_getGoods: '/companyadmin/v210623/decorate/getGoods',
  // 添加商品
  goods_add: '/companyadmin/v210623/goods/add',
  // 修改商品
  goods_edit: '/companyadmin/v210623/goods/edit',
  // 复制商品
  goods_copy: '/companyadmin/v210623/goods/copy_goods',
  // 删除商品
  goods_delete: '/companyadmin/v210623/goods/delete',
  // 批量添加到分类
  goods_add_to_cate: '/companyadmin/v210623/goods/add_to_cate',
  // 批量上架
  goods_up_shelf: '/companyadmin/v210623/goods/up_shelf',
  // 批量下架
  goods_down_shelf: '/companyadmin/v210623/goods/down_shelf',
  // 商品列表
  goods_cate_index: '/companyadmin/v210623/goods_cate/index',
  // 添加商品分类
  goods_cate_add: '/companyadmin/v210623/goods_cate/add',
  // 修改商品分类
  goods_cate_edit: '/companyadmin/v210623/goods_cate/edit',
  // 获取顶级分类列表
  goods_cate_parent_list: '/companyadmin/v210623/goods_cate/parent_list',
  // 删除分类
  goods_cate_delete: '/companyadmin/v210623/goods_cate/delete',
  // 订单列表
  order_index: '/companyadmin/v210623/order/index',
  // 售后管理列表
  order_after_sale: '/companyadmin/v210623/order/after_sale',
  // 商城首页
  decorate_index: '/companyadmin/v210623/decorate/index',
  // 商品详情页
  decorate_goods_detail: '/companyadmin/v210623/decorate/goods_detail',
  // 商品详情页
  decorate_edit: '/companyadmin/v210623/decorate/edit',
  // 上传文件p12 参数token
  uploadTokenImg: '/companyadmin/v210623/upload/uploadFile',
  // 上传文件p12 参数token   小程序备案
  uploadRecordTokenImg: '/companyadmin/v210623/upload/uploadxcxFile',
  // 多图上传
  uploadImgs: '/companyadmin/v210623/upload/uploadFiles',
  // 上传文件pem 参数token
  uploadUploadPemg: '/companyadmin/v210623/upload/uploadPem',
  // 上传视频 参数token
  uploadTokenVideo: '/companyadmin/v210623/upload/uploadVideo',
   // 上传视频 参数token     小程序备案
   uploadRecordTokenVideo: '/companyadmin/v210623/upload/uploadxcxVideo',
  // 上传图片 参数token
  uploadTokenAudio: '/companyadmin/v210623/upload/uploadAudio',
  // 上传图片upload-File
  uploadFile: '/api/upload/uploadFile',
  // 上传视频
  uploadVideo: '/api/upload/uploadVideo',
  // 上传音频
  uploadAudio: '/api/upload/uploadAudio',
  // 基础设置
  shopconf_index: '/companyadmin/v210623/shopconf/index',
  // 设置-修改
  shopconf_conf_edit: '/companyadmin/v210623/shopconf/conf_edit',
  // 售后设置
  shopconf_sale: '/companyadmin/v210623/shopconf/sale',
  // 售后设置-修改
  shopconf_sale_edit: '/companyadmin/v210623/shopconf/sale_edit',
  // 线下提成设置
  shopconf_commission: '/companyadmin/v210623/shopconf/commission',
  // 订单设置
  shopconf_order_conf_index: '/companyadmin/v210623/shopconf/order_conf_index', 
  // 订单设置-修改
  shopconf_order_conf_edit: '/companyadmin/v210623/shopconf/order_conf_edit',   
  // 购物车按钮配置
  shopconf_cart: '/companyadmin/v210623/shopconf/cart',
  // 标签
  shopconf_label: '/companyadmin/v210623/shopconf/label',
  // 标签-修改
  shopconf_label_edit: '/companyadmin/v210623/shopconf/label_edit',
  // 商城公告
  shopconf_notice: '/companyadmin/v210623/shopconf/notice',
  // 商城公告-修改
  shopconf_notice_edit: '/companyadmin/v210623/shopconf/notice_edit',
  // 商城公告-添加
  shopconf_notice_add: '/companyadmin/v210623/shopconf/notice_add',
  // 商城公告-删除
  shopconf_notice_delete: '/companyadmin/v210623/shopconf/notice_delete',
  // 企业动态
  diary_index: '/companyadmin/v210623/diary/index',
  diary_detail: '/companyadmin/v210623/diary/detail',
  diary_edit: '/companyadmin/v210623/diary/edit',
  diary_add: '/companyadmin/v210623/diary/add',
  diary_person: '/companyadmin/v210623/diary/person',
  diary_person: '/companyadmin/v210623/diary/person',
  diaryconf_index: '/companyadmin/v210623/diaryconf/index',
  diaryconf_edit: '/companyadmin/v210623/diaryconf/edit',
  programa_index: '/companyadmin/v210623/programa/index',
  programa_add: '/companyadmin/v210623/programa/add',
  programa_edit: '/companyadmin/v210623/programa/edit',
  programa_delete: '/companyadmin/v210623/programa/delete',
  // 运费模板列表
  freight_index: '/companyadmin/v210623/freight/index',
  // 运费模板详情
  freight_detail: '/companyadmin/v210623/freight/detail',
  // 删除运费模板
  freight_delete: '/companyadmin/v210623/freight/delete',
  // 添加运费模板
  freight_add: '/companyadmin/v210623/freight/add',
  // 修改运费模板
  freight_edit: '/companyadmin/v210623/freight/edit',
  // 包邮设置-信息
  freight_package_info: '/companyadmin/v210623/freight/package_info',
  // 包邮设置-修改
  freight_package_set: '/companyadmin/v210623/freight/package_set',
  // 获取省市区
  shopconf_get_address: '/companyadmin/v210623/shopconf/get_address',
  // 规格类目列表
  goods_attr_index: '/companyadmin/v210623/goods_attr/index',
  // 添加商品规格
  goods_attr_add: '/companyadmin/v210623/goods_attr/add',
  // 规格类目详情
  goods_attr_detail: '/companyadmin/v210623/goods_attr/detail',
  // 修改商品规格
  goods_attr_edit: '/companyadmin/v210623/goods_attr/edit',
  // 规格删除可行查询
  goods_attr_delete_check: '/companyadmin/v210623/goods_attr/delete_check',
  // 删除商品类目
  goods_attr_delete: '/companyadmin/v210623/goods_attr/delete',
  // 查询商品分类列表
  goods_goods_cate_list: '/companyadmin/v210623/goods/goods_cate_list',
  // 查询商品规格类目列表
  goods_attr_cate_list: '/companyadmin/v210623/goods/attr_cate_list',
  // 获取规格名称列表
  goods_attr_list: '/companyadmin/v210623/goods/attr_list',
  // 员工折扣列表
  discount_index: '/companyadmin/v210623/discount/index',
  // 特权优惠券
  // discount_coupon: '/companyadmin/v210623/discount/coupon',
  discount_coupon: '/companyadmin/v210623/Couponv2/couponBagList',
  // 特权优惠券添加
  discount_coupon_couponBag: '/companyadmin/v210623/Couponv2/couponBag',
  // 核销代金券（线下）列表
  coupon_verificationList: '/companyadmin/v210623/Couponv2/verificationList',
  // 核销代金券（线下）
  coupon_verification: '/companyadmin/v210623/Couponv2/verification',
  // 设置员工折扣
  discount_set_employee: '/companyadmin/v210623/discount/set_employee',
  // 设置公司员工基础折扣
  discount_set_discount: '/companyadmin/v210623/discount/set_discount',
  // 商品详情
  goods_detail: '/companyadmin/v210623/goods/detail',
  // 员工列表
  employee_index: '/companyadmin/v210623/employee/index',
  // 员工列表-删除
  employee_delete: '/companyadmin/v210623/employee/delete',
  // 员工设置APP管理员
  employee_set_appadmin: '/companyadmin/v210623/employee/set_appadmin',
  // 导出二维码页
  employee_download: '/companyadmin/v210623/radar/download',
  // 下载不同尺寸的二维码
  employee_get_qrcode: '/companyadmin/v210623/radar/get_qrcode',
  // 客户列表
  customer_index: '/companyadmin/v210623/customer/index',
  // 访客列表
  customer_visitor: '/companyadmin/v210623/customer/visitor',
  customer_integral_sms: '/companyadmin/v210623/customer/integralSms',
  customer_give_integral: '/companyadmin/v210623/customer/giveIntegral',
  // 标签管理
  tag_index: '/companyadmin/v210623/tag/index',
  // 标签添加
  tag_add: '/companyadmin/v210623/tag/add',
  // 标签修改
  tag_edit: '/companyadmin/v210623/tag/edit',
  // 标签删除
  tag_delete: '/companyadmin/v210623/tag/delete',
  // 标签分组添加
  tag_group_add: '/companyadmin/v210623/tag/group_add',
  // 标签分组修改
  tag_group_edit: '/companyadmin/v210623/tag/group_edit',
  // 标签分组删除
  tag_group_delete: '/companyadmin/v210623/tag/group_delete',
  // 组织架构开关设置
  employee_structure: '/companyadmin/v210623/employee/structure',
  // 添加员工
  employee_add: '/companyadmin/v210623/employee/add',
  // 删除员工
  employee_detail: '/companyadmin/v210623/employee/detail',
  // 员工编辑
  employee_edit: '/companyadmin/v210623/employee/edit',
  // 导出员工
  employee_out: '/companyadmin/v210623/employee/out',
  // 角色管理-列表
  role_index: '/companyadmin/v210623/role/index',
  // 角色管理-详情
  role_tree: '/companyadmin/v210623/role/tree',
  // 角色管理-添加角色
  role_add: '/companyadmin/v210623/role/add',
  // 角色管理-修改角色
  role_edit: '/companyadmin/v210623/role/edit',
  // 角色管理-删除角色
  role_delete: '/companyadmin/v210623/role/delete',
  // 雷达权限管理-员工管理
  radar_index: '/companyadmin/v210623/radar/index',
  // 雷达权限管理-开启/关闭AI雷达和名片
  radar_ai: '/companyadmin/v210623/radar/ai',
  // 雷达权限管理-开启/关闭BOSS雷达
  radar_boss: '/companyadmin/v210623/radar/boss',
  // 雷达权限管理-一键邀请激活APP
  radar_invite: '/companyadmin/v210623/radar/invite',
  // 未开通AI雷达员工列表
  radar_un_access: '/companyadmin/v210623/radar/un_access',
  // 批量开通AI雷达和名片
  radar_ai_open: '/companyadmin/v210623/radar/ai_open',
  // 锁粉设置
  fans_index: '/companyadmin/v210623/fans/index',
  // 锁粉设置-开启锁粉
  fans_open: '/companyadmin/v210623/fans/open',
  // 获取官网
  shopconf_get_website: '/companyadmin/v210623/shopconf/get_website',
  decorate_get_shopmall: '/companyadmin/v210623/decorate/get_shopmall',
  // 设置官网模版
  shopconf_set_website: '/companyadmin/v210623/shopconf/set_website',
  // 设置商城首页自定义模版
  decorate_set_shopmall: '/companyadmin/v210623/decorate/set_shopmall',
  // 获取地理分区
  freight_geographical_zone: '/companyadmin/v210623/freight/geographical_zone',
  // 部门列表
  department_index: '/companyadmin/v210623/department/index',
  // 获取子部门
  department_getchild: '/companyadmin/v210623/department/getchild',
  // 添加部门
  department_add: '/companyadmin/v210623/department/add',
  // 修改部门信息
  department_edit: '/companyadmin/v210623/department/edit',
  // 删除部门
  department_delete: '/companyadmin/v210623/department/delete',
  // 获取最上级部门
  companyadmin_get_alldepartment: '/companyadmin/v210623/employee/get_alldepartment',
  //获取当前部门员工及下级部门
  companyadmin_get_employee_child: '/companyadmin/v210623/employee/get_employee_child',
  // 搜索部门
  department_searchs: '/companyadmin/v210623/department/searchs',
  // 获取运费模板列表
  goods_freight: '/companyadmin/v210623/goods/freight',
  // 工作交接
  handover_index: '/companyadmin/v210623/handover/index',
  // 获取员工列表t
  handover_list: '/companyadmin/v210623/handover/list',
  // 获取员工客户数
  handover_customer: '/companyadmin/v210623/handover/customer',
  // 获取客户重合信息
  handover_customer_diff: '/companyadmin/v210623/handover/customer_diff',
  // 营销-引导关注
  accounts_guide: '/companyadmin/v210623/accounts/guide',
  // 营销-引导关注设置-修改
  accounts_guide_set: '/companyadmin/v210623/accounts/guide_set',
  // 营销-公众号自动回复
  accounts_keyword: '/companyadmin/v210623/accounts/keyword',
  // 营销-关键词自动回复-添加
  accounts_keyword_add: '/companyadmin/v210623/accounts/keyword_add',
  // 营销-关键词自动回复-编辑
  accounts_keyword_edit: '/companyadmin/v210623/accounts/keyword_edit',
  // 营销-关键词自动回复-删除
  accounts_keyword_delete: '/companyadmin/v210623/accounts/keyword_delete',
  // 营销-被关注自动回复
  accounts_attention: '/companyadmin/v210623/accounts/attention',
  // 营销-被关注自动回复-编辑
  accounts_attention_set: '/companyadmin/v210623/accounts/attention_set',
  // 批量修改运费
  goods_edit_shipping: '/companyadmin/v210623/goods/edit_shipping',
  // 批量修改佣金
  goods_edit_commission: '/companyadmin/v210623/goods/edit_commission',
  // 获取全局分销规则
  goods_distribution: '/companyadmin/v210623/goods/distribution',
  //批量转移到分类programa
  goods_move_to_cate: '/companyadmin/v210623/goods/move_to_cate',
  // 财务管理 -个人佣金
  financial_person: '/companyadmin/v210623/financial/person',
  // 财务管理 -个人佣金详情
  financial_person_detail: '/companyadmin/v210623/financial/personDetail',  
  // 财务管理 -员工佣金
  financial_employee: '/companyadmin/v210623/financial/employee',
  // 财务管理 -员工佣金详情
  financial_employee_detail: '/companyadmin/v210623/financial/detail',
  // 财务管理 -退款订单列表
  refund_order_index: '/companyadmin/v210623/refund_order/index',
  // 财务管理 -退款订单查看详情
  refund_order_detail: '/companyadmin/v210623/refund_order/detail',
  // 提现审核列表
  withdraw: '/companyadmin/v210623/withdraw/index',
  // 提现审核详情
  withdraw_detail: '/companyadmin/v210623/withdraw/detail',
  // 佣金设置
  withdraw_commission: '/companyadmin/v210623/withdraw/commission',
  // 佣金设置-修改
  withdraw_commission_set: '/companyadmin/v210623/withdraw/commission_set',
  // 订单管理-查看详情
  order_detail: '/companyadmin/v210623/order/detail',
  // 订单管理-删除
  order_delete: '/companyadmin/v210623/order/delete',
  // 订单管理-禁用
  order_forbid: '/companyadmin/v210623/order/forbid',
  // 订单管理-恢复
  order_resume: '/companyadmin/v210623/order/resume',
  // 订单管理-发货
  order_delivery: '/companyadmin/v210623/order/delivery',
  // 订单管理-获取物流公司列表
  order_shipping_list: '/companyadmin/v210623/order/shipping_list',
  // 订单管理-核销虚拟无物流商品
  order_writeOff:'/companyadmin/v210623/order/writeOff',
  // 订单导出excel
  order_out_excel: '/companyadmin/v210623/order/out_excel',
  // 名片管理
  card_index: '/companyadmin/v210623/card/index',
  // 名片详情
  card_detail: '/companyadmin/v210623/card/detail',
  // 名片修改 
  card_edit: '/companyadmin/v210623/card/edit',
  // 设为默认名片
  card_set_default: '/companyadmin/v210623/card/set_default',
  // 获取公众号二维码图片
  getPubQr: '/companyadmin/v210623/card/getPubQr',
  // 设置公众号二维码图片
  setPubQr: '/companyadmin/v210623/card/setPubQr',
  // 企业标签信息
  tags_index: '/companyadmin/v210623/tags/index',
  // 企业标签设置
  tags_set: '/companyadmin/v210623/tags/set',
  // 企业标签设置
  tags_delete: '/companyadmin/v210623/tags/delete',
  // 授权管理
  company_authorization: '/companyadmin/v210623/company/authorization',
  //发起人脸核身
  record_sendface:'/companyadmin/v210623/filings/createIcpVerifyTask',
  //获取单位性质
  record_workProperty:'/companyadmin/v210623/filings/queryIcpSubjectTypes',
  //获取证件类型
  record_certificateType:'/companyadmin/v210623/filings/queryIcpCertificateTypes',
  //获取区域信息
  record_districtCode:'/companyadmin/v210623/filings/queryIcpDistrictCode',
  //获取前置审批类型
  record_nrlxType:'/companyadmin/v210623/filings/queryIcpNrlxTypes',
  //获取小程序服务内容类型
  record_serverType:'/companyadmin/v210623/filings/queryIcpServiceContentTypes',
  //上传小程序备案媒体材料
  record_icpMediaType:'/companyadmin/v210623/filings/uploadIcpMedia',
  //获取人脸核身任务id , 状态 , 申请备案状态
  record_taskStatus:'/companyadmin/v210623/filings/TaskAndFilingStatus',
  //获取备案申请详情
  record_getApplyDetail:'/companyadmin/v210623/filings/get_filingsDetail',
  //申请备案提交
  record_applysumbit:'/companyadmin/v210623/filings/applyIcpFiling',
  // 授权管理-刷新
  company_refresh: '/companyadmin/v210623/company/refresh',
  // 授权管理-获客文章授权管理
  company_wxpub_index: '/companyadmin/v210623/wxpub/index',
  // 授权管理-获取公众号授权页面链接
  company_wxpub_wx_author: '/companyadmin/v210623/wxpub/wx_author',
  // 授权管理-获取公众号关联页面链接
  company_wxpub_wx_access: '/companyadmin/v210623/wxpub/wx_access',
  // 授权管理-刷新授权信息
  company_wxpub_refresh: '/companyadmin/v210623/wxpub/refresh',
  // 授权管理-开启/关闭文章同步
  company_wxpub_synchronous: '/companyadmin/v210623/wxpub/synchronous',
  // 提交版本审核(代小程序使用)
  company_submit_audit: '/companyadmin/v210623/company/submit_audit',
  // 修改授权小程序名称
  company_edit_name: '/companyadmin/v210623/company/edit_name',
  // 修改授权小程序头像
  company_modify_headimage: '/companyadmin/v210623/company/modify_headimage',
  // 修改功能介绍(代小程序使用)
  company_modifysignature: '/companyadmin/v210623/company/modifysignature',
  // 获取账号可以设置的所有类目(代小程序使用)
  company_getallcategories: '/companyadmin/v210623/company/getallcategories',
  // 添加类目(代小程序使用)
  company_addcategory: '/companyadmin/v210623/company/addcategory',
  // 删除类目(代小程序使用)
  company_deletecategory: '/companyadmin/v210623/company/deletecategory',
  // 上传临时素材
  upload_media: '/companyadmin/v210623/upload/media',
  // APP引导页海报
  companyadmin_get_poster: '/companyadmin/v210623/shopconf/get_poster',
  // APP默认引导页海报-设置
  companyadmin_set_poster: '/companyadmin/v210623/shopconf/set_poster',
  // APP特殊日期引导页海报-添加
  companyadmin_poster_add: '/companyadmin/v210623/shopconf/poster_add',
  // APP特殊日期引导页海报-编辑
  companyadmin_poster_edit: '/companyadmin/v210623/shopconf/poster_edit',
  // APP特殊日期引导页海报-删除
  companyadmin_poster_delete: '/companyadmin/v210623/shopconf/poster_delete',
  // 草稿箱
  companyadmin_draft_box: '/companyadmin/v210623/diary/draft_box',
  // 订单管理-售后订单查看详情
  order_refund_detail: '/companyadmin/v210623/order/refund_detail',
  // 订单管理-退款操作
  //order_refund_pass: '/companyadmin/v210623/order/refund_pass ',弃用
  // 订单管理-手动退款操作
  order_manual_refund: '/companyadmin/v210623/order/manual_refund',
  // 订单管理-退款拒绝
  order_refund_refuse: '/companyadmin/v210623/order/refund_refuse',
  // 官网装修招聘-招聘列表
  companyadmin_recruitment_index: '/companyadmin/v210623/recruitment/index',
  // 官网装修招聘-添加招聘
  companyadmin_recruitment_add: '/companyadmin/v210623/recruitment/add',
  // 官网装修招聘-招聘详情
  companyadmin_recruitment_detail: '/companyadmin/v210623/recruitment/detail',
  // 官网装修招聘-修改招聘
  companyadmin_recruitment_edit: '/companyadmin/v210623/recruitment/edit',
  // 官网装修招聘-删除招聘
  companyadmin_recruitment_delete: '/companyadmin/v210623/recruitment/delete',
  // 是否设置支付信息
  companyadmin_company_pay: '/companyadmin/v210623/company/pay',
  // 设置支付信息
  companyadmin_company_pay_set: '/companyadmin/v210623/company/pay_set',
  // 底部导航设置
  bottom_navigation_index: '/companyadmin/v210623/bottom_navigation/index',
  // 设置-修改
  bottom_navigation_edit: '/companyadmin/v210623/bottom_navigation/edit',
  // 底部导航分类
  bottom_navigation_cate: '/companyadmin/v210623/bottom_navigation/nav_cate',
  // 动态开关
  bottom_navigation_dynamic: '/companyadmin/v210623/bottom_navigation/dynamic',
  // 获取列表式图标
  bottom_navigation_list: '/companyadmin/v210623/bottom_navigation/list',
  // 获取二级套图图标
  bottom_navigation_sec_list: '/companyadmin/v210623/bottom_navigation/sec_list',
  // 小程序默认首页开关
  bottom_navigation_default_page: '/companyadmin/v210623/bottom_navigation/defaultPage',
  // 名片模块
  companyadmin_get_module: '/companyadmin/v210623/card/get_module',
  // 设置名片模块
  companyadmin_set_module: '/companyadmin/v210623/card/set_module',
  // 推广路径 小程序主页
  companyadmin_path_index: '/companyadmin/v210623/promontion_path/index',
  // 推广路径 商品列表
  companyadmin_path_goods: '/companyadmin/v210623/promontion_path/goods',
  // 推广路径 导出二维码页
  companyadmin_path_download: '/companyadmin/v210623/promontion_path/download',
  // 推广路径 下载不同尺寸的二维码
  companyadmin_path_get_qrcode: '/companyadmin/v210623/promontion_path/get_qrcode',
  // 企业后台 发送修改手机号验证码
  companyadmin_send_code: 'companyadmin/v210623/company/send_code',
  // 授权验证
  distribution_index: 'companyadmin/v210623/distribution/index',
  distribution_check: 'companyadmin/v210623/distribution/check',
  distribution_set: 'companyadmin/v210623/distribution/set',
  distribution_judge: 'companyadmin/v210623/distribution/judge',
  // 企业后台 验证修改手机号验证码
  companyadmin_check_code: '/companyadmin/v210623/company/check_code',
  // 企业后台 修改手机号
  companyadmin_edit_phone: '/companyadmin/v210623/company/edit_phone',
  // 企业后台 修改账号
  companyadmin_edit_username: '/companyadmin/v210623/company/edit_username',
  //营销-视频
  companyadmin_video_diary_index: '/companyadmin/v210623/video_diary/index',
  companyadmin_video_diary_add: '/companyadmin/v210623/video_diary/add',
  companyadmin_video_diary_edit: '/companyadmin/v210623/video_diary/edit',
  companyadmin_video_diary_detail: '/companyadmin/v210623/video_diary/detail',
  companyadmin_video_diary_delete: '/companyadmin/v210623/video_diary/delete',
  //营销-表单列表
  companyadmin_form_list: '/companyadmin/v210623/activity_form/index',
  companyadmin_form_edit: '/companyadmin/v210623/activity_form/edit',
  companyadmin_form_detail: '/companyadmin/v210623/activity_form/detail',
  companyadmin_form_moban:'/companyadmin/v210623/activity_form/formTemple',
  companyadmin_form_use:'/companyadmin/v210623/activity_form/useTemplate',
  companyadmin_form_editstatus:'/companyadmin/v210623/activity_form/editStatus',
  companyadmin_form_settype:'/companyadmin/v210623/activity_form/setType',
  companyadmin_form_delete:'/companyadmin/v210623/activity_form/delete',
  companyadmin_form_downcode:'/companyadmin/v210623/activity_form/downCode',
  companyadmin_form_getcode:'/companyadmin/v210623/activity_form/getQrcode',
  companyadmin_form_headimg:'/companyadmin/v210623/activity_form/headImg',
  companyadmin_form_shareimg:'/companyadmin/v210623/activity_form/shareImg',
  companyadmin_form_preview:'/companyadmin/v210623/activity_form/preview',
  companyadmin_form_data:'/companyadmin/v210623/activity_form/formData',
  companyadmin_form_fdetail:'/companyadmin/v210623/activity_form/formDetail',
  companyadmin_form_report:'/companyadmin/v210623/activity_form/report',
  // 表单报表（新）
  companyadmin_form_reportNew:'/companyadmin/v210623/activity_form/reportNew',
  //营销预约表单
  appointmentList:'/companyadmin/v210623/ActivityForm/appointmentList',
  checkAppointment:'/companyadmin/v210623/ActivityForm/checkAppointment',//预约核销
  cancelAppointment:'/companyadmin/v210623/ActivityForm/cancelAppointment',//取消预约
  // 营销-宣传册
  brochure_index: '/companyadmin/v210623/brochure/index',
  brochure_edit_status: '/companyadmin/v210623/brochure/editStatus',
  brochure_recommend: '/companyadmin/v210623/brochure/recommend',
  brochure_down_code: '/companyadmin/v210623/brochure/downCode',
  brochure_get_qrcode: '/companyadmin/v210623/brochure/getQrcode',
  brochure_goods_list: '/companyadmin/v210623/brochure/goodsList',
  brochure_form_list: '/companyadmin/v210623/brochure/formList',
  brochure_background_list: '/companyadmin/v210623/brochure/backgroundList',
  brochure_detail: '/companyadmin/v210623/brochure/detail',
  brochure_pagedel: '/companyadmin/v210623/brochure/pageDel',
  brochure_add: '/companyadmin/v210623/brochure/add',
  brochure_edit: '/companyadmin/v210623/brochure/edit',
  brochure_file: '/companyadmin/v210623/brochure/fileToImg',
  brochure_delete: '/companyadmin/v210623/brochure/delete',
  
  // 营销-企业相册
  album_index: '/companyadmin/v210623/Album/index',
  album_detail: '/companyadmin/v210623/Album/detail',
  album_save: '/companyadmin/v210623/Album/save',
  album_delete: '/companyadmin/v210623/Album/delete',
  album_change_status: '/companyadmin/v210623/Album/changeStatus',
  knowledge_get: '/companyadmin/v210623/Knowledge/getConf',
  knowledge_add: '/companyadmin/v210623/Knowledge/addChannel',
  knowledge_del: '/companyadmin/v210623/Knowledge/delChannel',
  knowledge_set: '/companyadmin/v210623/Knowledge/setVideo',
  knowledge_sort_channel: '/companyadmin/v210623/Knowledge/sortChannel',

  // 财务-提现审核通过-驳回
  companyadmin_withdraw_confirm: '/companyadmin/v210623/withdraw/confirm',
  // 财务-提现审核列表-待打款-导出excel
  companyadmin_withdraw_out_excel: '/companyadmin/v210623/withdraw/out_excel',
  // 提现审核_待打款_修改状态_确定
  companyadmin_withdraw_change_state: '/companyadmin/v210623/withdraw/changeState',

  // 客户列表-导出
  companyadmin_Customer_out_excel: '/companyadmin/v210623/Customer/out_excel',
  // 访客列表-导出
  companyadmin_Customer_out_excel_visitor: '/companyadmin/v210623/Customer/out_excel_visitor',

  // 概况-系统公告-查看更多
  companyadmin_index_newsList: '/companyadmin/v210623/index/newsList',
  companyadmin_index_newsDetail: '/companyadmin/v210623/index/newsDetail',
  // 参考标签
  tags_getLabel: '/companyadmin/v210623/tags/getLabel',
  
  // 授权管理-订阅消息首页
  subscribe_message_list: '/companyadmin/v210623/company/subscribeMessageList', 
  // 授权管理-订阅消息配置-配置
  subscribe_config: '/companyadmin/v210623/company/subscribeConfig', 
  // 授权管理-订阅消息配置-获取小程序帐号下的个人模板库
  subscribe_message_template: '/companyadmin/v210623/company/subscribeMessageTemplate', 
  // 授权管理-订阅消息配置-删除小程序帐号下的个人模板
  subscribe_message_del_template: '/companyadmin/v210623/company/subscribeMessageDelTemplate', 
  // 客户列表-设置专属顾问-确定按钮
  customer_setCounselor: '/companyadmin/v210623/customer/setCounselor',
  // 工单首页
  represent_index: '/companyadmin/v210623/represent/index',
  // 新增工单前获取问题类型
  represent_before_add: '/companyadmin/v210623/represent/before_add',
  // 提交工单
  represent_add: '/companyadmin/v210623/represent/add',
  // 工单详情
  represent_info: '/companyadmin/v210623/represent/info',
  // 工单详情-继续反馈
  represent_continue_add: '/companyadmin/v210623/represent/continue_add',
  // 工单详情-确认结束
  represent_confirm: '/companyadmin/v210623/represent/confirm',
  // 工单详情-删除
  represent_del: '/companyadmin/v210623/represent/del',

  // 积分商城
  points_index: '/companyadmin/v210623/PointsMall/index',
  points_detail: '/companyadmin/v210623/PointsMall/detail',
  points_add: '/companyadmin/v210623/PointsMall/add',
  points_edit: '/companyadmin/v210623/PointsMall/edit',
  points_copy: '/companyadmin/v210623/PointsMall/copy_goods',
  points_delete: '/companyadmin/v210623/PointsMall/delete',
  points_up_shelf: '/companyadmin/v210623/PointsMall/up_shelf',
  points_down_shelf: '/companyadmin/v210623/PointsMall/down_shelf',
  points_goods_cate_list: '/companyadmin/v210623/PointsMall/goods_cate_list',
  points_add_to_cate: '/companyadmin/v210623/PointsMall/add_to_cate',
  points_move_to_cate: '/companyadmin/v210623/PointsMall/move_to_cate',
  points_attr_list: '/companyadmin/v210623/PointsMall/attr_list',
  points_attr_cate_list: '/companyadmin/v210623/PointsMall/attr_cate_list',
  points_signInConfig: '/companyadmin/v210623/PointsMall/signInConfig',
  points_setSignInConfig: '/companyadmin/v210623/PointsMall/setSignInConfig',
  points_integralDetails: '/companyadmin/v210623/PointsMall/integralDetails',

  information_index: '/companyadmin/v210623/Information/index',
  information_detail: '/companyadmin/v210623/Information/detail',
  information_add: '/companyadmin/v210623/Information/add',
  information_edit: '/companyadmin/v210623/Information/edit',
  information_delete: '/companyadmin/v210623/Information/delete',

  //拓客接口
  // 单文件上传
  uploadFile: "/companyadmin/v210623/upload/uploadFile",
  //拓客概况
  homePage :"/companyadmin/v210623/Tuoke/homePage",
  homeTrend: "/companyadmin/v210623/Tuoke/homeTrend", 
  sortSku: "/companyadmin/v210623/Tuoke/sortSku", 
  sortPrize: "/companyadmin/v210623/Tuoke/sortPrize",
  
  //活动列表
  activityIndex: '/companyadmin/v210623/Tuoke/index',
  templateList: '/companyadmin/v210623/Tuoke/templateList',
  activityDetail: '/companyadmin/v210623/Tuoke/detail',
  activityDelete: '/companyadmin/v210623/Tuoke/deleteActivity',
  submitBasic: '/companyadmin/v210623/Tuoke/submitBasic',
  submitAdvanced: '/companyadmin/v210623/Tuoke/submitAdvanced',
  submitPrize: '/companyadmin/v210623/Tuoke/submitPrize',
  prizeDel: '/companyadmin/v210623/Tuoke/prizeDel',
  getShareInfo: "/companyadmin/v210623/Tuoke/getShareInfo",
  submitSku: '/companyadmin/v210623/Tuoke/submitsku',
  skuDel: '/companyadmin/v210623/Tuoke/skuDel',
  setStatus: '/companyadmin/v210623/Tuoke/setStatus',
  copyByUrl: '/companyadmin/v210623/Tuoke/copyByUrl',
  oneClickClone: '/companyadmin/v210623/Tuoke/oneClickClone',
  getCitys: '/companyadmin/v210623/Tuoke/getCitys',
  getInvitationLog: '/companyadmin/v210623/Tuoke/getInvitationLog',
  getJoinLog: '/companyadmin/v210623/Tuoke/getJoinLog',
  getBuyLog: '/companyadmin/v210623/Tuoke/getBuyLog',
  setVerificationStatus: '/companyadmin/v210623/Tuoke/setVerificationStatus',
  withdrawMoney: '/companyadmin/v210623/Tuoke/withdrawMoney',
  withdrawRecord: '/companyadmin/v210623/Tuoke/withdrawRecord',
  capitalFlow: '/companyadmin/v210623/Tuoke/capitalFlow',
  //分销员认证
  recommendList: '/companyadmin/v210623/Tuoke/recommendList',
  changeRecommend : '/companyadmin/v210623/Tuoke/changeRecommend',
  recommendData: '/companyadmin/v210623/Tuoke/recommendData',
  // 联盟商家列表
  diffUserList : "/companyadmin/v210623/Tuoke/diffUserList", 
  // 新增联盟商家
  addDifferentIndustry: "/companyadmin/v210623/Tuoke/addDifferentIndustry", 
  // 联盟商家下拉列表
  otherDifferentIndustry: "/companyadmin/v210623/Tuoke/otherDifferentIndustry",
  //删除联盟商家
  diffUserDel: "/companyadmin/v210623/Tuoke/diffUserDel",
  //企业员工列表
  employeeList : "/companyadmin/v210623/Tuoke/employeeList",
  //异业商家绑定二维码
  showDiffQr : "/companyadmin/v210623/Tuoke/showDiffQr",
  //活动列表（简单信息）
  activityListEasy : "/companyadmin/v210623/Tuoke/activityListEasy",
  //添加员工弹出的海报
  addAlert: "/companyadmin/v210623/Worker/addAlert",
  //查看员工数据
  workerStaff: "/companyadmin/v210623/Worker/index",
  //抽奖日志
  getDrawLog: "/companyadmin/v210623/Tuoke/getDrawLog",
  checkDrawCode : "/companyadmin/v210623/Tuoke/checkDrawCode",
  getDycode: "/companyadmin/v210623/Tuoke/getDycode",
  checkDouyin: "/companyadmin/v210623/Tuoke/checkDouyin",
  //拓客-所有访客列表
  visitorList: "/companyadmin/v210623/Tuoke/visitorList",
  
  //导入手机号表格黑名单
  impForbid : "/companyadmin/v210623/Tuoke/impForbid",
  //添加访客黑名单
  visForbid: "/companyadmin/v210623/Tuoke/visForbid",
  //黑名单列表
  forbidList : "/companyadmin/v210623/Tuoke/forbidList ",
  //删除黑名单
  delForbid : "/companyadmin/v210623/Tuoke/delForbid  ",
  //添加合伙人
  partnerAdd : "/companyadmin/v210623/Partner/add",
  //合伙人列表
  partnerLists : "/companyadmin/v210623/Partner/lists",
  // 编辑合伙人
  partner_edit : "/companyadmin/v210623/Partner/edit",
  //删除合伙人
  partner_del : "/companyadmin/v210623/Partner/del",
  //启用禁用合伙人
  partner_changeStatus : "/companyadmin/v210623/Partner/changeStatus",
  //入股记录
  partner_ruguLog : "/companyadmin/v210623/Partner/ruguLog",
  //客源记录
  partner_customerList : "/companyadmin/v210623/Partner/customerList",
  //购买订单
  partner_buyLog : "/companyadmin/v210623/Partner/buyLog",
  //分红方案
  partner_schemeList : "/companyadmin/v210623/Partner/schemeList",
  //添加分红方案
  partner_schemeAdd : "/companyadmin/v210623/Partner/schemeAdd",
  //编辑分红方案
  partner_schemeEdit : "/companyadmin/v210623/Partner/schemeEdit",
  //删除分红方案
  partner_schemeDel : "/companyadmin/v210623/Partner/schemeDel",
  //合伙人、方案、项目列表
  partner_partnerAndScheme : "/companyadmin/v210623/Partner/partnerAndScheme",
  //派发方案
  partner_distribution : "/companyadmin/v210623/Partner/distribution",
  //汇总分析
  partner_index : "/companyadmin/v210623/Partner/index",
  //商品毛利率列表
  goodsProfit : "/companyadmin/v210623/Partner/goodsProfit",
   //设置毛利率
   setProfit  : "/companyadmin/v210623/Partner/setProfit ",
  //核销购买记录
  partner_buyCheck : "/companyadmin/v210623/Partner/buyCheck",
  //手动添加购买记录
  partner_buyAdd : "/companyadmin/v210623/Partner/buyAdd",
  //合伙人详情
  partner_detail : "/companyadmin/v210623/Partner/detail",
  //方案详情
  partner_schemeDetail : "/companyadmin/v210623/Partner/schemeDetail",
  //提现列表
  partner_withdrawalList : "/companyadmin/v210623/Partner/withdrawalList",
   //处理提现
   partner_handleWithdrawal : "/companyadmin/v210623/Partner/handleWithdrawal",






};
